import { useState, useEffect } from 'react';
import { useParams, Link } from 'react-router-dom';
import SEOMeta from '@/components/feature/SEOMeta';
import Breadcrumb from '@/components/feature/Breadcrumb';
import ArticleCard from '@/components/base/ArticleCard';
import { categories, allArticles } from '@/mocks/data';

export default function CategoryPage() {
  const { slug } = useParams<{ slug: string }>();
  const [activeTab, setActiveTab] = useState(slug || categories[0].slug);

  useEffect(() => {
    if (slug) setActiveTab(slug);
  }, [slug]);

  const currentCategory = categories.find((c) => c.slug === activeTab) || categories[0];
  const categoryArticles = allArticles.filter((a) => a.category === activeTab);

  const catNames: Record<string, string> = {};
  categories.forEach((c) => { catNames[c.slug] = c.name; });

  return (
    <>
      <SEOMeta
        title={`${currentCategory.name} - 性欲社`}
        description={`性欲社${currentCategory.name}栏目，${currentCategory.description}。浏览专业、科学的${currentCategory.name}文章。`}
        keywords={`${currentCategory.name},性欲社,两性健康,性教育,亲密关系`}
        canonicalUrl={`https://sportsix.github.io/category/${activeTab}`}
      />

      <main className="pt-24 pb-16 min-h-screen">
        <div className="w-full px-4 md:px-6">
          <div className="max-w-7xl mx-auto">
            {/* Breadcrumb */}
            <Breadcrumb
              items={[
                { label: '首页', to: '/' },
                { label: currentCategory.name },
              ]}
            />

            {/* Category Header */}
            <div className="mt-6 mb-10">
              <h1 className="text-2xl md:text-3xl font-heading font-bold text-foreground-900">
                {currentCategory.name}
              </h1>
              <p className="mt-2 text-sm md:text-base text-foreground-500 max-w-2xl">
                {currentCategory.description}
              </p>
            </div>

            {/* Tab Switcher */}
            <div className="flex items-center gap-2 overflow-x-auto pb-2 mb-10 flex-wrap">
              {categories.map((cat) => (
                <Link
                  key={cat.slug}
                  to={`/category/${cat.slug}`}
                  className={`px-4 py-2 text-sm font-medium rounded-full transition-all duration-200 whitespace-nowrap cursor-pointer ${
                    activeTab === cat.slug
                      ? 'bg-primary-500 text-background-50'
                      : 'bg-background-100 text-foreground-600 hover:bg-background-200'
                  }`}
                >
                  <i className={`${cat.icon} mr-1.5 text-xs`}></i>
                  {cat.name}
                </Link>
              ))}
            </div>

            {/* Articles Grid */}
            {categoryArticles.length > 0 ? (
              <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5 md:gap-6">
                {categoryArticles.map((article) => (
                  <ArticleCard
                    key={article.slug}
                    slug={article.slug}
                    title={article.title}
                    excerpt={article.excerpt}
                    image={article.image}
                    author={article.author}
                    date={article.date}
                    readTime={article.readTime}
                    category={article.category}
                    categoryName={catNames[article.category] || ''}
                  />
                ))}
              </div>
            ) : (
              <div className="text-center py-20">
                <div className="w-16 h-16 mx-auto flex items-center justify-center rounded-full bg-background-100">
                  <i className="ri-inbox-line text-2xl text-foreground-400"></i>
                </div>
                <p className="mt-4 text-foreground-500">该分类暂无文章，敬请期待</p>
                <Link
                  to="/"
                  className="mt-4 inline-block text-sm text-primary-500 hover:text-primary-600 transition-colors cursor-pointer"
                >
                  返回首页
                </Link>
              </div>
            )}
          </div>
        </div>
      </main>
    </>
  );
}